"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputFactory = _interopRequireDefault(require("../InputFactory"));
var _OutputFactory = _interopRequireDefault(require("../OutputFactory"));
var _excluded = ["onChange", "field", "object", "onSubmit", "icon", "label", "placeholder", "edit", "hidden"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputInfo/index.js";
var defaultProps = {
  type: "String",
  edit: true,
  hidden: false
};
function InputInfo(_ref) {
  var onChange = _ref.onChange,
    field = _ref.field,
    object = _ref.object,
    onSubmit = _ref.onSubmit,
    icon = _ref.icon,
    label = _ref.label,
    placeholder = _ref.placeholder,
    edit = _ref.edit,
    hidden = _ref.hidden,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isEdit = _React$useState2[0],
    setEdit = _React$useState2[1];
  var value = object[field];
  function _onSubmit(e) {
    e.preventDefault();
    setEdit(false);
    onSubmit(e);
  }
  function onclickCancel() {
    setEdit(false);
  }
  if (isEdit) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
      className: "list-group-item text-nowrap text-truncate",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react["default"].createElement("form", {
      onSubmit: _onSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 21
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label fs-sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 25
      }
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: icon,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 29
      }
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "ms-2 fw-light text-capitalize",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 29
      }
    }, label)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mt-1",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 25
      }
    }, /*#__PURE__*/_react["default"].createElement(_InputFactory["default"], Object.assign({
      field: field,
      object: object,
      onChange: onChange,
      placeholder: placeholder
    }, props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 29
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "my-3 text-end",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 29
      }
    }, edit && /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary fs-xs",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 44,
        columnNumber: 42
      }
    }, "SAVE"), /*#__PURE__*/_react["default"].createElement("button", {
      onClick: onclickCancel,
      className: "btn btn-light fs-xs ms-2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 33
      }
    }, "CANCEL"))))));
  }
  var editLabel = value ? 'Edit' : 'Add';
  var actionLabel = hidden ? 'Show' : editLabel;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    className: "list-group-item clamp",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2 me-1 fw-light text-capitalize",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 17
    }
  }, label), (edit || hidden) && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setEdit(true);
    },
    className: "btn btn-link p-0 fs-sm float-end",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 42
    }
  }, actionLabel), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fs-sm text-nowrap",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 17
    }
  }, !hidden && /*#__PURE__*/_react["default"].createElement(_OutputFactory["default"], Object.assign({
    field: field,
    object: object
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 37
    }
  })), hidden && "*** *** ***")));
}
InputInfo.defaultProps = defaultProps;
var _default = exports["default"] = InputInfo;